import {Signals} from "@/Imports";
import Facade from "@/Facade";
import GameStatesEnum from "@/states/GameStatesEnum";

export default class AutoplayManager {

    constructor () {
        this.didBet1 = false
        this.didBet2 = false
        Signals.makeBets.add(this.onMakeBets, this)
        Signals.autoBetButtonClicked.add(this.onAutoBetButtonClicked, this)
    }

    onMakeBets() {
        if(Facade.model.autoBet1) {
            this.makeAutoBet1()
        }
        if(Facade.model.autoBet2) {
            this.makeAutoBet2()
        }
    }

    onAutoBetButtonClicked() {
        if (!Facade.model.autoBet1) {

            this.didBet1 = false
        }
        if (!Facade.model.autoBet2) {
            this.didBet2 = false
        }
        if(Facade.model.stateMachine.currentStateName == GameStatesEnum.MAKE_BETS) {
            if(!this.didBet1 && Facade.model.autoBet1) {
                this.makeAutoBet1()
            }
            if(!this.didBet2 && Facade.model.autoBet2) {
                this.makeAutoBet2()
            }
        }
    }

    makeAutoBet1() {
        this.didBet1 = true
        if(Facade.model.setAutoBet1 > 0) {
            Facade.model.setAutoBet1--
        }
        Signals.gameMessage.dispatch({
            message: 'bet',
            amount: Facade.model.currentBet1,
            autoCollect: Facade.model.ac1 ? Facade.model.currentAutoCollect1 : 0,
            cell: 1
        })
    }

    makeAutoBet2() {
        this.didBet2 = true
        if(Facade.model.setAutoBet2 > 0) {
            Facade.model.setAutoBet2--
        }

        Signals.gameMessage.dispatch({
            message: 'bet',
            amount: Facade.model.currentBet2,
            autoCollect: Facade.model.ac2 ? Facade.model.currentAutoCollect2 : 0,
            cell: 2
        })
    }

}